// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import PartyBookMarkedTable from './PartyBookMarkedTable/PartyBookMarkedTable';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import PartyPollsTable from './PartyPollsTable/PartyPollsTable';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import CollapsableItem from '../../utils/CollapsableItem';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const PartyBehavior = ({ bookMarked, polls, history, isExpanded }) => {
  return (
    <div className='data-box'>
      <h4 className='header'>Party Behavior</h4>
      <CollapsableItem isExpanded={isExpanded}>
        <PartyBookMarkedTable bookMarked={bookMarked} />
        <PartyPollsTable polls={polls} history={history} />
      </CollapsableItem>
    </div>
  );
};

export default React.memo(PartyBehavior);
